import { Component, OnInit, Inject, Optional } from '@angular/core';
import { Pipe, PipeTransform } from '@angular/core';
import { ProjectPipelineInfo } from '../model/projectpipeline.model'
import { ProjectSaleInfo } from '../model/projectsale.model'
import { LookupInfo } from '../model/lookup.model';
import { EmpInfo } from '../model/emp.model';
import { FormBuilder, FormGroup, FormArray, Validators, AbstractControl, FormControl, Form } from '@angular/forms';
import { BaselineInfo } from '../model/baseline.model';
import { GlobalService } from '../service/global.service';
import { Chart, ChartType, ChartOptions } from 'chart.js'; //Add from lesson learned tab
import { SingleDataSet, Label, monkeyPatchChartJsLegend, monkeyPatchChartJsTooltip } from 'ng2-charts'; //Add from lesson learned tab

import { Observable, Subject } from 'rxjs';
import {
  HttpEventType,
  HttpClient,
  HttpHeaders
} from "@angular/common/http";
import {
  environment
} from 'src/environments/environment';
import { data } from 'jquery';
import { NgModule } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CompanyInfo } from '../model/company.model';
import { TokenService } from '../service/token.service';
import { SaleTeamMappingEmployeeInfo } from '../model/SaleTeamMappingEmployeeInfo.model';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material/dialog';
import { UpdatePipelineDialogComponent } from '../component/update-pipeline-dialog/update-pipeline-dialog.component';
import { ProjectPipelineDetailComponent } from './project-pipeline-detail/project-pipeline-detail.component';
import { ServiceDeliveryBacklogDetailComponent } from '../service-delivery-backlog-detail/service-delivery-backlog-detail.component';
import { NgZone } from '@angular/core'; // Import NgZone

@Component({
  selector: 'app-pipe-line',
  templateUrl: './pipe-line.component.html',
  styleUrls: ['./pipe-line.component.css']
})
export class PipeLineComponent implements OnInit {

  displayloading: boolean = false;
  Msgloadding: string = '';
  public body: string;

  ProjectPipelineListPromise: Promise<ProjectPipelineInfo[]>
  ProjectPipelineList: ProjectPipelineInfo[]
  ProjectPipelinePromisereturn: Promise<ProjectPipelineInfo[]>[]
  ProjectSaleListPromise: Promise<ProjectSaleInfo[]>
  ProjectSaleList: ProjectSaleInfo[]
  ProjectSaleListPromisereturn: Promise<ProjectSaleInfo[]>[]
  empList: EmpInfo[]
  empListLoad: EmpInfo[]
  empListPromise: Promise<EmpInfo[]>
  empListPromiseReturn: Promise<EmpInfo[]>

  // Search Zone
  ddlSearchCompany: string = null
  SearchProjectSaleList: ProjectSaleInfo[]
  ddlSearchProjectSaleList: ProjectSaleInfo[]
  ddlSearchProjectSaleCode: string = null
  PipelineStatusList: LookupInfo[] = []
  ddlSearchPipelineStatus: string = null
  //txtSearchUpdateDate: string = null
  txtSearchExpectedClosePeriod: string = null

  txtSearchDate: string
  txtExpectedClose: string
  ddlProjectSaleCode: string
  txtAmount: number
  txtCommission: number
  ddlCompany: string
  ddlProjectSaleList: ProjectSaleInfo[]
  ddlProjectPriority: string
  ddlProjectProgress: string
  txtProbability: number
  txtRemark: string
  monthNumber: number
  sum: number

  isOnUpdate: boolean;
  isSubmitted: any;

  element: HTMLElement;
  public hidcouchk: number;
  public countall: number;

  baseurl: string;
  getreturn: Promise<string>;
  monthNameslist: any;
  PriorityList: any;
  ProgressList: any;
  yearlist: any[];
  dataSet: any[];
  yearMonthSet: any[] = [];
  CompanyList: CompanyInfo[] = [];

  txtSearchSaleTeam: string = null;
  txtSearchSaleTeamMember: string = null;
  //txtSearchWinRate: number

  // Period search fields
  periodSearch: string = null;
  yearSearch: number | null = null;
  quarterSearch: string | null = null;
  monthSearch: any | null = null;
  yearOptions: number[] = [];
  quarterOptions: string[] = ["Q1", "Q2", "Q3", "Q4"];
  monthOptions: any[] = [
    { value: 1, label: "January" },
    { value: 2, label: "February" },
    { value: 3, label: "March" },
    { value: 4, label: "April" },
    { value: 5, label: "May" },
    { value: 6, label: "June" },
    { value: 7, label: "July" },
    { value: 8, label: "August" },
    { value: 9, label: "September" },
    { value: 10, label: "October" },
    { value: 11, label: "November" },
    { value: 12, label: "December" }
  ];

  SaleTeamList: SaleTeamMappingEmployeeInfo[] = [];
  SaleTeamUnderList: SaleTeamMappingEmployeeInfo[] = [];

  _ForK2: string;
  _EmpCode: string;
  _ParamEmpCode: string;
  _ParamTeamCode: string;
  _ParamTeamName: string;
  FlagViewNotClosed: string;

  //PROJECTSALECLOSEDEALPROGRESS
  ProjectStatusList: LookupInfo[] = [];
  /*********** End variables *************/

  // save current sort ExpectedClosePeriod
  currentsortExpectedClosePeriod: string = 'sortup';
  uniqueProjectCount: number = 0;

  MyEmployeeNameWithUnder: string = '';

  // Add properties to store date range from dialog data
  startDate: string;
  endDate: string;
  periodLabel: string;
  employeeCodeFilter: string;

  // Column filters for ProjectSaleCode
  columnFilters: { [key: string]: string } = {};

  ProjectPipelineAPI: string = 'ProjectPipeline/GetProjectPipeline';

  constructor(
    private httpClient: HttpClient,
    @Inject('BASE_URL') baseUrl: string,
    private formBuilder: FormBuilder,
    private GlobalService: GlobalService,
    private activatedRoute: ActivatedRoute,
    private TokenService: TokenService,
    @Optional() public dialogRef: MatDialogRef<PipeLineComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router,
    private ngZone: NgZone // Inject NgZone
  ) {
    this.baseurl = environment.base_api;
    this._ForK2 = this.activatedRoute.snapshot.params.ForK2;
    this._ParamEmpCode = this.activatedRoute.snapshot.params.EmpCode;


    // If this is opened as a dialog, use the dialog data
    if (data) {
      this._ParamTeamCode = data._ParamTeamCode.toString();
      this._ParamTeamName = data._ParamTeamName.toString();
      this.FlagViewNotClosed = data.FlagViewNotClosed.toString();

      this.ProjectPipelineAPI = "Dashboard/GetDashboardProjectPipeline";

      // Get date range parameters if provided
      this.startDate = data.StartDate || null;
      this.endDate = data.EndDate || null;
      this.periodLabel = data.PeriodLabel || null;
      this.employeeCodeFilter = data.EmployeeCode || null;

      // If we have a period label and date range, set up the period search
      if (this.periodLabel && this.startDate && this.endDate) {
        const startDate = new Date(this.startDate);
        this.yearSearch = startDate.getFullYear();

        // Determine if it's a quarter or month
        if (this.periodLabel.startsWith('Q')) {
          this.periodSearch = 'QUARTER';
          this.quarterSearch = this.periodLabel;
        } else {
          this.periodSearch = 'MONTH';
          // Find the month option that matches the period label
          const monthOption = this.monthOptions.find(m => m.label === this.periodLabel);
          if (monthOption) {
            this.monthSearch = monthOption.value;
          }
        }
      }
    } else {
      GlobalService.CheckPagingAccessRights();
    }

    // Initialize year list for period search
    const currentYear = new Date().getFullYear();
    this.yearOptions = Array.from({ length: 5 }, (_, i) => currentYear - i);
  }

  async ngOnInit() {
    this.periodSearch = "YEAR";
    this.yearSearch = this.yearOptions[0];

    this._EmpCode = !!this._ParamEmpCode ? this._ParamEmpCode : localStorage.getItem("EmpCode");
    if (!!this._ForK2) {
      localStorage.setItem("EmpCode", this._ParamEmpCode);
    }
    // Load Project Sale for Search
    this.LoadSearchProjectSaleList();
    // Load Pipeline status
    this.GlobalService.loadLookup('PIPELINESTATUS').then((data) => {
      this.PipelineStatusList = data;
    });

    this.LoadProjectSale();
    this.LoadSaleTeam();

    this.loadDDLPriority().then((data) => {
      this.PriorityList = data
    });
    this.loadDDLProgress().then((data) => {
      this.ProgressList = data
    });
    this.loadDDLCompany().then((data) => {
      this.CompanyList = data
    });

    this.LoadProjectPipeline();
  }

  public btnSearchPipeline_OnClick() {
    this.LoadProjectPipelineList("initial");

  }

  public btnclearPipeline_OnClick() {
    this.ddlSearchCompany = null;
    this.ddlSearchProjectSaleCode = null;
    this.ddlSearchPipelineStatus = null;
    //this.txtSearchUpdateDate = null;
    this.txtSearchExpectedClosePeriod = null;
    this.txtSearchSaleTeam = null;
    this.txtSearchSaleTeamMember = null;
    //this.txtSearchWinRate = null;

    // Reset period search fields
    this.periodSearch = null;
    this.yearSearch = null;
    this.quarterSearch = null;
    this.monthSearch = null;

    this.LoadProjectPipelineList("initial");
  }

  public onDateChanged(event) {
    this.txtSearchDate = event.target.value;
    this.LoadProjectPipelineList();
  }

  async LoadProjectPipeline() {
    await this.LoadProjectPipelineList("initial");
  }

  // Helper method to get month name from month number
  getMonthName(monthNumber: string | null): string {
    if (!monthNumber) return '';

    const monthNames = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];

    const monthIndex = parseInt(monthNumber) - 1;
    return monthNames[monthIndex] || '';
  }

  async LoadProjectPipelineList(customsort = null) {

    try {
      this.displayloading = true;

      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = {};

        //debugger;

        // Use employee code from dialog data if available, otherwise use the selected employee from dropdown
        let selectedemp = this.employeeCodeFilter ||
          (this.txtSearchSaleTeamMember != null &&
            this.txtSearchSaleTeamMember != undefined &&
            this.txtSearchSaleTeamMember != "" ?
            this.txtSearchSaleTeamMember : null);

        if (this.FlagViewNotClosed == "Y") {
          this.txtSearchSaleTeam = this._ParamTeamCode;
          objectjson['ProjectPipelineCustomFilter'] = "NOTCLOSED";
        } else {
          objectjson['ProjectPipelineCreateBy'] = selectedemp;
        }

        if (this._ParamTeamCode != null) {
          this.txtSearchSaleTeam = this._ParamTeamCode;
        }

        if (selectedemp != null) {
          objectjson['ProjectPipelineCreateBy'] = selectedemp;
        }

        if (selectedemp == null && this.FlagViewNotClosed != "N") {
          objectjson['AllUnderEmpCode'] = this._EmpCode;
        }

        objectjson['ProjectPipelineFlagDelete'] = "N";

        objectjson['ProjectPipelineFlagDelete'] = "N";
        objectjson['ProjectPipelineCompanyCode'] = this.checkUndefinedString(this.ddlSearchCompany);
        objectjson['ProjectSaleCode'] = this.checkUndefinedString(this.ddlSearchProjectSaleCode);
        objectjson['ProjectPipelineStatusLookupCode'] = this.checkUndefinedString(this.ddlSearchPipelineStatus);
        //objectjson['ProjectPipelineUpdateDate'] = this.checkUndefinedDate(this.txtSearchUpdateDate);
        objectjson['ProjectPipelineClose'] = this.checkUndefinedDate(this.txtSearchExpectedClosePeriod);
        //objectjson['ProjectPipelineProbability'] = this.txtSearchWinRate ?? 0;
        objectjson['ProjectPipelineSaleTeamCode'] = this.checkUndefinedDate(this.txtSearchSaleTeam);

        // Add period search date range - first check direct date parameters, then fall back to period search
        if (this.startDate && this.endDate) {
          // Use direct date parameters passed from dashboard
          objectjson['ProjectPipelineSearchStartDate'] = this.startDate;
          objectjson['ProjectPipelineSearchEndDate'] = this.endDate;
        } else {
          // Fall back to period search if no direct dates
          const dateRange = this.getDateRangeFromPeriodSearch();
          if (dateRange && dateRange.startDate && dateRange.endDate && this.periodSearch != null && this.periodSearch != "") {
            objectjson['ProjectPipelineSearchStartDate'] = dateRange.startDate;
            objectjson['ProjectPipelineSearchEndDate'] = dateRange.endDate;
          }
        }

        let strjson = JSON.stringify(objectjson);

        this.httpClient.post<ProjectPipelineInfo[]>(this.baseurl + this.ProjectPipelineAPI, strjson, httpOptions)
          .toPromise().then((data) => {
            this.ProjectPipelineList = data
            this.hidcouchk = data.length;

            // Count unique projects
            this.countUniqueProjects();

            //ชุดใหม่

            this.renderPipelineList(this.ProjectPipelineList, customsort);


          });


      }



    } catch (error) {
      //console.log(error);
    } finally {
      this.displayloading = false;
    }

  }

  async LoadSaleTeam() {

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      objectjson['EmployeeCode'] = this.checkUndefinedString(this._EmpCode);

      let strjson = JSON.stringify(objectjson);

      this.httpClient.post<SaleTeamMappingEmployeeInfo[]>(this.baseurl + "Team/GetEmpMappingTeam", strjson, httpOptions)
        .toPromise().then((data) => {
          this.SaleTeamList = data

          if (this.SaleTeamList.length > 0) {
            this.MyEmployeeNameWithUnder = this.SaleTeamList[0].EmployeeName;
          }
        });
    }
  }

  // Period search event handlers
  async onPeriodChange() {
    //this.yearSearch = null;
    this.quarterSearch = null;
    this.monthSearch = null;

    await this.btnSearchPipeline_OnClick();
  }

  async onYearChange() {
    await this.btnSearchPipeline_OnClick();
  }

  async onQuarterChange() {
    this.monthSearch = null;
    await this.btnSearchPipeline_OnClick();
  }

  async onMonthChange() {
    this.quarterSearch = null;
    await this.btnSearchPipeline_OnClick();
  }

  // Helper method to convert period search selections to date range
  getDateRangeFromPeriodSearch(): { startDate: string, endDate: string } | null {
    // If no period is selected or no year is selected, return null
    if (this.periodSearch === "" || !this.yearSearch) {
      return null;
    }

    let startDate: Date;
    let endDate: Date;

    if (this.periodSearch === 'YEAR') {
      // Full year
      startDate = new Date(this.yearSearch, 0, 1); // January 1st
      endDate = new Date(this.yearSearch, 11, 31); // December 31st
    }
    else if (this.periodSearch === 'QUARTER' && this.quarterSearch != null && this.quarterSearch != "") {
      // Specific quarter
      const quarter = parseInt(this.quarterSearch.substring(1));
      const startMonth = (quarter - 1) * 3;
      startDate = new Date(this.yearSearch, startMonth, 1);

      // End date is last day of the last month in the quarter
      const endMonth = startMonth + 2;
      endDate = new Date(this.yearSearch, endMonth + 1, 0);
    }
    else if (this.periodSearch === 'MONTH' && this.monthSearch != null && this.monthSearch != "") {
      // Specific month
      const month = parseInt(this.monthSearch);
      startDate = new Date(this.yearSearch, month - 1, 1);

      // End date is last day of the month
      endDate = new Date(this.yearSearch, month, 0);
    }
    else if ((this.periodSearch === 'MONTH' && (this.monthSearch == null || this.monthSearch == "")) || (this.periodSearch === 'QUARTER' && (this.quarterSearch == null || this.quarterSearch == "")) && this.yearSearch != null) {
      // Full year
      startDate = new Date(this.yearSearch, 0, 1); // January 1st
      endDate = new Date(this.yearSearch, 11, 31); // December 31st
    }
    else {
      return null;
    }

    // Set specific times for start and end dates
    // Start date at 00:00:00
    startDate.setHours(0, 0, 0, 0);
    // End date at 23:59:59
    endDate.setHours(23, 59, 59, 999);

    // Format dates as strings in YYYY-MM-DD format with time
    const formatDate = (date: Date): string => {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const seconds = date.getSeconds().toString().padStart(2, '0');
      return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    };

    return {
      startDate: formatDate(startDate),
      endDate: formatDate(endDate)
    };
  }

  async LoadSaleTeamUnders() {

    this.SaleTeamUnderList = [];
    this.txtSearchSaleTeamMember = null;

    this.btnSearchPipeline_OnClick();

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      objectjson['SaleTeamCode'] = this.checkUndefinedString(this.txtSearchSaleTeam);
      objectjson['EmployeesUnder'] = this.checkUndefinedString(this._EmpCode);
      objectjson['AssignedSellerOnly'] = true;
      objectjson['MyEmployeeCodeWithUnder'] = this.checkUndefinedString(this._EmpCode);
      objectjson['MyEmployeeNameWithUnder'] = this.checkUndefinedString(this.MyEmployeeNameWithUnder);
      //objectjson['IncludeSelf'] = true;

      let strjson = JSON.stringify(objectjson);

      this.httpClient.post<SaleTeamMappingEmployeeInfo[]>(this.baseurl + "Team/GetEmpMappingTeam", strjson, httpOptions)
        .toPromise().then((data) => {
          this.SaleTeamUnderList = data
        });
    }
  }


  SortExpectedClosePeriod() {
    if (this.currentsortExpectedClosePeriod == 'sortup') {
      this.renderPipelineList(this.ProjectPipelineList, 'sortdown');
      this.currentsortExpectedClosePeriod = 'sortdown';
    } else {
      this.renderPipelineList(this.ProjectPipelineList, 'sortup');
      this.currentsortExpectedClosePeriod = 'sortup';
    }
  }

  renderPipelineList(ProjectPipelineList: ProjectPipelineInfo[], sort: string = 'sortdown') {
    var orderred = ProjectPipelineList.sort((a, b) => Date.parse(b.ProjectPipelineClose) - Date.parse(a.ProjectPipelineClose));
    if (sort == 'sortup') {
      orderred = orderred.reverse();
    } else if (sort == 'initial') {
      orderred = ProjectPipelineList.sort((a, b) => Date.parse(b.ProjectPipelineCreateDate) - Date.parse(a.ProjectPipelineCreateDate));
    } else if (sort == 'sortdown') {
      orderred = ProjectPipelineList.sort((a, b) => Date.parse(b.ProjectPipelineClose) - Date.parse(a.ProjectPipelineClose));
    }


    //Loop 2
    var yearMonthSet = [];
    var groupByCompany = new Set(orderred.map(item => item.ProjectPipelineCompanyCode))
    groupByCompany.forEach(companyCode => {

      var result = [];
      var dataGroupByCompany = orderred.filter(i => i.ProjectPipelineCompanyCode === companyCode);
      var dataCompanyName = dataGroupByCompany[0].ProjectPipelineCompanyName;

      //Loop 3
      var groupByProjCode = new Set(dataGroupByCompany.map(item => item.ProjectSaleCode));
      groupByProjCode.forEach(projCode => {


        //child arr 3
        result.push({
          name: projCode,
          owner: dataGroupByCompany.filter(i => i.ProjectSaleCode === projCode)[0].ProjectPipelineDisplayCreateBy,
          values: dataGroupByCompany.filter(i => i.ProjectSaleCode === projCode),
          sumAmount: dataGroupByCompany.filter(i => i.ProjectSaleCode === projCode).map(tag => tag.ProjectPipelineAmount).reduce((a, b) => { return a + b; }, 0), //this.ProjectPipelineList.map(tag => tag.ProjectPipelineAmount).reduce((a, b) => a + b, 0),
          sumComission: this.sumcommission(projCode, dataGroupByCompany),
          sumComissionPercent: dataGroupByCompany.filter(i => i.ProjectSaleCode === projCode).map(tag => tag.ProjectPipelineComission).reduce((a, b) => { return a + b; }, 0),
        });

      });

      //child arr 2
      yearMonthSet.push({
        companyCode: companyCode,
        companyName: dataCompanyName,
        result: result
      });

    });

    this.yearMonthSet = yearMonthSet;
  }

  async btnClick_submitInsertPipeline() {
    if (this.validated()) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.OnCreating('y');
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = {};
        objectjson['ProjectSaleCode'] = this.ddlProjectSaleCode
        objectjson['ProjectPipelineClose'] = this.checkUndefinedDate(this.txtExpectedClose)
        objectjson['ProjectPipelineAmount'] = this.txtAmount
        objectjson['ProjectPipelineComission'] = this.txtCommission
        objectjson['ProjectPipelinePriority'] = this.checkUndefinedString(this.ddlProjectPriority)
        objectjson['ProjectPipelineProgress'] = this.checkUndefinedString(this.ddlProjectProgress)
        objectjson['ProjectPipelineProbability'] = this.txtProbability
        objectjson['ProjectPipelineRemark'] = this.checkUndefinedString(this.txtRemark)
        objectjson['ProjectPipelineCreateBy'] = this.checkUndefinedString(this._EmpCode)
        objectjson['ProjectPipelineFlagDelete'] = "N";

        let strjson = JSON.stringify(objectjson);

        this.isSubmitted = this.httpClient.post<ProjectPipelineInfo[]>(this.baseurl + "ProjectPipeline/InsertProjectPipeline", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            //console.log("Insert fail")
            this.OnCreating('n');
          },
            () => {
              //console.log("Insert = " + this.isSubmitted)
              this.OnCreating('n');
              $('#ModalCreateComplate').modal();
              this.ngOnInit();
            }
          )
      }
    }
  }

  LoadProjectSale() {
    this.LoadProjectSaleList();
  }

  async LoadSearchProjectSaleList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      objectjson['ProjectSaleFlagDelete'] = "N";


      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/GetProjectSale", strjson, httpOptions)
        .toPromise().then((data) => {
          this.SearchProjectSaleList = data;
        });
    }


  }
  async LoadProjectSaleList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      objectjson['ProjectSaleAssignTo'] = this.checkUndefinedString(this._EmpCode);
      objectjson['ProjectSaleFlagDelete'] = "N";


      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/GetProjectSale", strjson, httpOptions)
        .toPromise().then((data) => {
          this.ProjectSaleList = data.filter((x) => { return x.ProjectSaleCloseDealProgress != '4' })
          this.hidcouchk = data.length;

          this.ddlProjectSaleList = data;
        });
    }

  }

  async loadDDLPriority() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let strjson = "{\"LookupType\":\"ISSUEPRIORITY\" }";

      return await this.httpClient.post<any>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
        .toPromise()
    }
  }

  async loadDDLProgress() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let strjson = "{\"LookupType\":\"PROJECTSALECLOSEDEALPROGRESS\" }";

      return await this.httpClient.post<any>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
        .toPromise()
    }
  }

  async loadDDLCompany() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let strjson = "{}";
      return await this.httpClient.post<CompanyInfo[]>(this.baseurl + "Company/GetCompany", strjson, httpOptions)
        .toPromise()
    }
  }

  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput

  }

  checkUndefinedDate(strInput: string) {
    if (strInput === undefined || strInput === null || strInput === '') {
      strInput = null
    }
    return strInput

  }

  loading(flag: boolean, Msg: string = '') {
    this.displayloading = flag;
    this.Msgloadding = Msg;
  }

  OnCreating(flag) {
    if (flag == 'y') {
      $("#loadingcreate").show();
      $("#btnsubmitpipeline").hide();
      $("#ddlProjectSaleCode").prop('disabled', true);
      $("#txtExpectedClose").prop('disabled', true);
      $('#txtAmount').prop('disabled', true);
      $('#txtCommission').prop('disabled', true);
      $('#ddlProjectPriority').prop('disabled', true);
      $('#txtProbability').prop('disabled', true);
      $('#txtRemark').prop('disabled', true);
    } else if (flag == 'n') {
      $("#loadingcreate").hide();
      $("#btnsubmitpipeline").show();
      $("#ddlProjectSaleCode").removeAttr('disabled');
      $("#txtExpectedClose").removeAttr('disabled');
      $('#txtAmount').removeAttr('disabled');
      $('#txtCommission').removeAttr('disabled');
      $('#ddlProjectPriority').removeAttr('disabled');
      $('#txtProbability').removeAttr('disabled');
      $('#txtRemark').removeAttr('disabled');
      $('#modalProjectPipelineController').modal('hide');
    }

  }

  OnBtnAddPipeLineClick() {

    this.ddlCompany = "";
    this.ddlProjectSaleCode = "";
    this.ddlProjectProgress = "";
    this.txtExpectedClose = "";
    this.txtExpectedClose = "";
    this.txtAmount = null;
    this.txtCommission = null;
    this.txtProbability = null;

    $('#ddlCompany').css('border-color', 'inherit');
    $('#ddlProjectSaleCode').css('border-color', 'inherit');
    $('#ddlProjectProgress').css('border-color', 'inherit');
    $('#txtExpectedClose').css('border-color', 'inherit');
    $('#txtAmount').css('border-color', 'inherit');
    $('#txtCommission').css('border-color', 'inherit');
    $('#txtProbability').css('border-color', 'inherit');

  }

  OnPipeLineEditClick() {

  }

  checkIfAllowEditPipeline(item: any) {
    return item?.ProjectPipelineCreateBy == localStorage.getItem('EmpCode')
  }

  openPipelineUpdateDialog(stage: any = null, itemlist: any, isViewMode: boolean = false): void {

    // If item is an array (like item.values), get the latest one by ProjectPipelineCreateDate
    let latestItemlist = itemlist;
    let item = itemlist;

    if (Array.isArray(itemlist)) {
      // Sort by ProjectPipelineCreateDate in descending order (newest first)
      const sortedItems = [...itemlist].sort((a, b) => {
        const dateA = new Date(a.ProjectPipelineCreateDate || 0);
        const dateB = new Date(b.ProjectPipelineCreateDate || 0);
        return dateB.getTime() - dateA.getTime(); // Descending order
      });

      // Use the first item after sorting (which will be the latest)
      latestItemlist = sortedItems.length > 0 ? sortedItems[0] : {};

      item = latestItemlist[0];
    }

    const dialogRef = this.dialog.open(UpdatePipelineDialogComponent, {
      width: '800px',
      autoFocus: false,
      data: {
        stage: stage,
        ProjectSaleCode: item?.ProjectSaleCode ?? null, //must
        ProjectSaleCreateBy: item?.ProjectSaleCreateBy ?? null,
        ProjectPipelineId: isViewMode ? item?.ProjectPipelineId : null,
        ProjectPipelineSubStateCode: isViewMode ? item?.ProjectPipelineSubStateCode : null,
        //ProjectPipelineStatusLookupCode: isViewMode ? item?.ProjectPipelineStatusLookupCode : null,
        ProjectPipelineStatusLookupCode: item?.ProjectPipelineStatusLookupCode,
        ProjectPipelineClose: item?.ProjectPipelineClose,// isViewMode ? item?.ProjectPipelineClose : null,
        ProjectPipelineAmount: isViewMode ? item?.ProjectPipelineAmount : null,
        ProjectPipelineComission: isViewMode ? item?.ProjectPipelineComission : null,
        ProjectPipelinePriority: isViewMode ? item?.ProjectPipelinePriority : null,
        ProjectPipelineProbability: isViewMode ? item?.ProjectPipelineProbability : null,
        ProjectPipelineRemark: isViewMode ? item?.ProjectPipelineRemark : null,
        ProjectPipelineCreateBy: isViewMode ? item?.ProjectPipelineCreateBy : null,
        ProjectPipelineFlagDelete: isViewMode ? item?.ProjectPipelineFlagDelete : null,
        ProjectSaleCloseDealProgress: item?.ProjectSaleCloseDealProgress ?? null, //must
        ProjectSaleTeamCode: item?.ProjectSaleTeamCode ?? null,  //must
        ProjectPipelineProjectSaleId: item?.ProjectPipelineProjectSaleId ?? null,  //must
        ProjectSaleAssignTo: item?.ProjectSaleAssignTo ?? null,
        isViewMode: isViewMode
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result?.success) {
        if (result.reload) {
          this.LoadProjectPipeline();
        }
      } else if (result?.error) {
        console.error('Error saving pipeline:', result.error);
      }
    });
  }

  onClose(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }

  openServiceDeliveryBacklogDetail(item: ProjectPipelineInfo): void {
    // Create a dialog configuration
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = false;
    dialogConfig.width = '80%';
    dialogConfig.maxHeight = '90vh';
    dialogConfig.data = {
      ServiceDeliveryBacklogProjectSaleCode: item.ProjectSaleCode,
      ServiceDeliveryBacklogProjectSaleName: item.ProjectSaleName
    };

    // Open the dialog
    const dialogRef = this.dialog.open(ServiceDeliveryBacklogDetailComponent, dialogConfig);

    // Handle dialog close event if needed
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.reload) {
        // Handle any actions after dialog closes if needed
        this.LoadProjectPipeline();
      }
    });
  }

  // Filter items in a column by ProjectSaleCode
  filterColumnItems(event: any, statusCode: string) {
    const filterValue = event.target.value.toLowerCase().trim();
    this.columnFilters[statusCode] = filterValue;

    // Use NgZone to ensure Angular knows about our DOM changes
    this.ngZone.run(() => {
      // Use a more reliable approach to find the column and items
      const inputElement = event.target;
      const column = inputElement.closest('.kanban-column');
      if (!column) return;

      // Get all items in this column
      const items = column.querySelectorAll('.kanban-item');

      // Apply filtering
      items.forEach((item: HTMLElement) => {
        const strongElement = item.querySelector('strong');
        if (strongElement) {
          const projectCode = strongElement.innerText.toLowerCase();
          if (projectCode.includes(filterValue)) {
            item.style.display = '';
          } else {
            item.style.display = 'none';
          }
        }
      });
    });
  }

  //--------- Private
  sumcommission(groupname: string, listfilter: any[]) {
    var sumresult = 0;

    var amtArr = listfilter.filter(i => i.ProjectSaleCode === groupname)
    amtArr.forEach((item, idx) => {

      sumresult += (item.ProjectPipelineAmount * (item.ProjectPipelineComission / 100));
    });
    return sumresult
  }

  getHighestPipelineStatus(items: any[]): number {
    if (!items || items.length === 0) return 0;
    return Math.max(...items.map(item => item.ProjectPipelineStatusLookupCode || 0));
  }

  getLatestCreatedPipelineStatus(items: any[]): number {
    if (!items || items.length === 0) return 0;
    // Sort by create date (newest first) and return the status of the first item
    const sortedItems = [...items].sort((a, b) =>
      new Date(b.ProjectPipelineCreateDate).getTime() - new Date(a.ProjectPipelineCreateDate).getTime()
    );
    return sortedItems.length > 0 ? parseInt(sortedItems[0].ProjectPipelineStatusLookupCode) || 0 : 0;
  }

  getLatestPipelineStarStatus(items: any[]): number {
    if (!items || items.length === 0) return 0;
    // Sort by create date (newest first) and return the status of the first item
    const sortedItems = [...items].sort((a, b) =>
      new Date(b.ProjectPipelineCreateDate).getTime() - new Date(a.ProjectPipelineCreateDate).getTime()
    );
    return sortedItems.length > 0 ? parseInt(sortedItems[0].ProjectPipelineStatusLookupCode) || 0 : 0;
  }

  getPipelineSubStateCode(items: any[]): string {
    if (!items || items.length === 0) return '';
    const closedItem = items.find(item => item.ProjectPipelineStatusLookupCode === '6');
    return closedItem ? closedItem.ProjectPipelineSubStateCode : '';
  }

  countUniqueProjects(): void {
    if (this.ProjectPipelineList && this.ProjectPipelineList.length > 0) {
      // Filter out placeholder items for the standard count
      const regularItems = this.ProjectPipelineList.filter(
        item => item.ProjectPipelineSubStateCode !== '1-5-1-PLACEHOLDER'
      );

      // Count unique projects by ProjectSaleCode (excluding placeholders)
      const uniqueProjects = new Set(regularItems.map(item => item.ProjectSaleCode));
      let count = uniqueProjects.size;

      // Find all items with the special placeholder state code
      const placeholderItems = this.ProjectPipelineList.filter(
        item => item.ProjectPipelineSubStateCode === '1-5-1-PLACEHOLDER' || item.ProjectPipelineSubStateCode === '1-5-1'
      );

      // For each placeholder item, count its backlog entries
      let backlogEntryCount = 0;
      placeholderItems.forEach(item => {
        // Count waiting backlog items if they exist
        if (item.ServiceDeliveryBacklogDetailListWaiting &&
          item.ServiceDeliveryBacklogDetailListWaiting.length > 0) {
          backlogEntryCount += item.ServiceDeliveryBacklogDetailListWaiting.length;
        }

        // Count new business backlog items if they exist
        if (item.ServiceDeliveryBacklogDetailListNewBusiness &&
          item.ServiceDeliveryBacklogDetailListNewBusiness.length > 0) {
          backlogEntryCount += item.ServiceDeliveryBacklogDetailListNewBusiness.length;
        }
      });

      // Add the backlog entry count to the unique projects count
      this.uniqueProjectCount = count + backlogEntryCount;
    } else {
      this.uniqueProjectCount = 0;
    }
  }

  getItemsForStatus(statusCode: string): ProjectPipelineInfo[] {
    if (!this.ProjectPipelineList) return [];

    // Group all items by ProjectSaleCode
    const projectGroups = new Map<string, ProjectPipelineInfo[]>();

    this.ProjectPipelineList.forEach(item => {
      if (!projectGroups.has(item.ProjectSaleCode)) {
        projectGroups.set(item.ProjectSaleCode, []);
      }
      projectGroups.get(item.ProjectSaleCode).push(item);
    });

    // For each project, find the latest item and check if it belongs in this column
    const result: ProjectPipelineInfo[] = [];

    projectGroups.forEach((items, projectCode) => {
      // Sort by create date (newest first)
      const sortedItems = [...items].sort((a, b) =>
        new Date(b.ProjectPipelineCreateDate).getTime() - new Date(a.ProjectPipelineCreateDate).getTime()
      );

      // Get the latest item
      const latestItem = sortedItems[0];

      // Check if it belongs in this column
      // Skip if it should be in Suspended or Terminated columns
      if (latestItem &&
        latestItem.ProjectPipelineStatusLookupCode === statusCode &&
        latestItem.ProjectSaleState !== '1-9' && // Not suspended
        latestItem.ProjectSaleState !== '0') {    // Not terminated
        result.push(latestItem);
      }
    });

    return result;
  }

  getEmployeeColor(employeeCode: string): string {
    if (!employeeCode) return '#cccccc';

    // Generate a consistent color based on the employee code
    let hash = 0;
    for (let i = 0; i < employeeCode.length; i++) {
      hash = employeeCode.charCodeAt(i) + ((hash << 5) - hash);
    }

    // Convert to a hex color
    let color = '#';
    for (let i = 0; i < 3; i++) {
      const value = (hash >> (i * 8)) & 0xFF;
      color += ('00' + value.toString(16)).substr(-2);
    }

    return color;
  }

  getItemsForClosedStatus(subStateCode: string): ProjectPipelineInfo[] {
    if (!this.ProjectPipelineList) return [];

    // Group all items by ProjectSaleCode
    const projectGroups = new Map<string, ProjectPipelineInfo[]>();

    this.ProjectPipelineList.forEach(item => {
      if (!projectGroups.has(item.ProjectSaleCode)) {
        projectGroups.set(item.ProjectSaleCode, []);
      }
      projectGroups.get(item.ProjectSaleCode).push(item);
    });

    // For each project, find the latest item and check if it belongs in this column
    const result: ProjectPipelineInfo[] = [];

    projectGroups.forEach((items, projectCode) => {
      // Sort by create date (newest first)
      const sortedItems = [...items].sort((a, b) =>
        new Date(b.ProjectPipelineCreateDate).getTime() - new Date(a.ProjectPipelineCreateDate).getTime()
      );

      // Get the latest item
      const latestItem = sortedItems[0];

      // Check if it belongs in this column (status code 6 and matching substate)
      // Skip if it should be in Suspended or Terminated columns
      if (latestItem &&
        latestItem.ProjectPipelineStatusLookupCode === '6' &&
        latestItem.ProjectPipelineSubStateCode === subStateCode &&
        latestItem.ProjectSaleState !== '1-9' && // Not suspended
        latestItem.ProjectSaleState !== '0') {    // Not terminated
        result.push(latestItem);
      }
    });

    return result;
  }

  getNonClosedStatuses(): LookupInfo[] {
    if (!this.PipelineStatusList) return [];
    return this.PipelineStatusList.filter(s => s.LookupCode !== '6');
  }

  getItemsForSuspendedStatus(): ProjectPipelineInfo[] {
    if (!this.ProjectPipelineList) return [];

    // Group all items by ProjectSaleCode
    const projectGroups = new Map<string, ProjectPipelineInfo[]>();

    this.ProjectPipelineList.forEach(item => {
      if (!projectGroups.has(item.ProjectSaleCode)) {
        projectGroups.set(item.ProjectSaleCode, []);
      }
      projectGroups.get(item.ProjectSaleCode).push(item);
    });

    // For each project, find the latest item and check if it belongs in this column
    const result: ProjectPipelineInfo[] = [];

    projectGroups.forEach((items, projectCode) => {
      // Sort by create date (newest first)
      const sortedItems = [...items].sort((a, b) =>
        new Date(b.ProjectPipelineCreateDate).getTime() - new Date(a.ProjectPipelineCreateDate).getTime()
      );

      // Get the latest item
      const latestItem = sortedItems[0];

      // Check if it belongs in suspended column (ProjectSaleState = '1-9')
      if (latestItem && latestItem.ProjectSaleState === '1-9') {
        result.push(latestItem);
      }
    });

    return result;
  }

  getItemsForTerminatedStatus(): ProjectPipelineInfo[] {
    if (!this.ProjectPipelineList) return [];

    // Group all items by ProjectSaleCode
    const projectGroups = new Map<string, ProjectPipelineInfo[]>();

    this.ProjectPipelineList.forEach(item => {
      if (!projectGroups.has(item.ProjectSaleCode)) {
        projectGroups.set(item.ProjectSaleCode, []);
      }
      projectGroups.get(item.ProjectSaleCode).push(item);
    });

    // For each project, find the latest item and check if it belongs in this column
    const result: ProjectPipelineInfo[] = [];

    projectGroups.forEach((items, projectCode) => {
      // Sort by create date (newest first)
      const sortedItems = [...items].sort((a, b) =>
        new Date(b.ProjectPipelineCreateDate).getTime() - new Date(a.ProjectPipelineCreateDate).getTime()
      );

      // Get the latest item
      const latestItem = sortedItems[0];

      // Check if it belongs in terminated column (ProjectSaleState = '0')
      if (latestItem && latestItem.ProjectSaleState === '0') {
        result.push(latestItem);
      }
    });

    return result;
  }





  getItemsForWaitingStatus(): ProjectPipelineInfo[] {
    if (!this.ProjectPipelineList) return [];

    const result: ProjectPipelineInfo[] = [];

    // Go through all pipeline items
    this.ProjectPipelineList.forEach(pipeline => {
      // Check if the pipeline has waiting backlog items
      if (pipeline.ServiceDeliveryBacklogDetailListWaiting &&
        pipeline.ServiceDeliveryBacklogDetailListWaiting.length > 0) {

        // For each backlog item, create a new pipeline item
        pipeline.ServiceDeliveryBacklogDetailListWaiting.forEach(backlogItem => {
          const newPipelineItem = new ProjectPipelineInfo();

          // Map backlog properties to pipeline properties
          newPipelineItem.ProjectSaleCode = backlogItem.ServiceDeliveryBacklogDetailBacklogNo;
          newPipelineItem.ProjectSaleName = pipeline.ProjectSaleName;
          newPipelineItem.ProjectPipelineRemark = backlogItem.ServiceDeliveryBacklogDetailBacklogDesc;
          newPipelineItem.ProjectPipelineAmount = backlogItem.ServiceDeliveryBacklogDetailPrice;
          newPipelineItem.ProjectPipelineCreateBy = pipeline.ProjectPipelineCreateBy;//backlogItem.ServiceDeliveryBacklogDetailCreateBy;
          newPipelineItem.ProjectPipelineDisplayCreateBy = pipeline.ProjectPipelineDisplayCreateBy;//backlogItem.ServiceDeliveryBacklogDetailCreateByDisplay;

          // Copy other useful properties from the parent pipeline
          newPipelineItem.ProjectPipelineCompanyCode = pipeline.ProjectPipelineCompanyCode;
          newPipelineItem.ProjectPipelineCompanyName = pipeline.ProjectPipelineCompanyName;

          // Add estimated date if available
          newPipelineItem.ProjectPipelineCreateDate = backlogItem.ServiceDeliveryBacklogDetailEstimateDate;

          // Add to result
          result.push(newPipelineItem);
        });
      }
    });

    return result;
  }

  getItemsForNewBusinessStatus(): ProjectPipelineInfo[] {
    if (!this.ProjectPipelineList) return [];

    const result: ProjectPipelineInfo[] = [];

    // Go through all pipeline items
    this.ProjectPipelineList.forEach(pipeline => {
      // Check if the pipeline has new business backlog items
      if (pipeline.ServiceDeliveryBacklogDetailListNewBusiness &&
        pipeline.ServiceDeliveryBacklogDetailListNewBusiness.length > 0) {

        // For each backlog item, create a new pipeline item
        pipeline.ServiceDeliveryBacklogDetailListNewBusiness.forEach(backlogItem => {
          const newPipelineItem = new ProjectPipelineInfo();

          // Map backlog properties to pipeline properties
          newPipelineItem.ProjectSaleCode = backlogItem.ServiceDeliveryBacklogDetailBacklogNo;
          newPipelineItem.ProjectSaleName = pipeline.ProjectSaleName;
          newPipelineItem.ProjectPipelineRemark = backlogItem.ServiceDeliveryBacklogDetailBacklogDesc;
          newPipelineItem.ProjectPipelineAmount = backlogItem.ServiceDeliveryBacklogDetailPrice;
          newPipelineItem.ProjectPipelineCreateBy = pipeline.ProjectPipelineCreateBy;//backlogItem.ServiceDeliveryBacklogDetailCreateBy;
          newPipelineItem.ProjectPipelineDisplayCreateBy = pipeline.ProjectPipelineDisplayCreateBy;//backlogItem.ServiceDeliveryBacklogDetailCreateByDisplay;

          // Copy other useful properties from the parent pipeline
          newPipelineItem.ProjectPipelineCompanyCode = pipeline.ProjectPipelineCompanyCode;
          newPipelineItem.ProjectPipelineCompanyName = pipeline.ProjectPipelineCompanyName;

          // Add actual date if available
          newPipelineItem.ProjectPipelineCreateDate = backlogItem.ServiceDeliveryBacklogDetailActualDate;

          // Add to result
          result.push(newPipelineItem);
        });
      }
    });

    return result;
  }

  // Calculate the sum of amounts for items in the Waiting column
  getWaitingTotalAmount(): number {
    const waitingItems = this.getItemsForWaitingStatus();
    if (!waitingItems || waitingItems.length === 0) return 0;

    return waitingItems.reduce((sum, item) => {
      return sum + (item.ProjectPipelineAmount || 0);
    }, 0);
  }

  // Calculate the sum of amounts for items in the New Business column
  getNewBusinessTotalAmount(): number {
    const newBusinessItems = this.getItemsForNewBusinessStatus();
    if (!newBusinessItems || newBusinessItems.length === 0) return 0;

    return newBusinessItems.reduce((sum, item) => {
      return sum + (item.ProjectPipelineAmount || 0);
    }, 0);
  }
















  // Calculate the sum of amounts for items in a specific status column
  getColumnTotalAmount(statusCode: string): number {
    const items = this.getItemsForStatus(statusCode);
    if (!items || items.length === 0) return 0;

    return items.reduce((sum, item) => sum + (item.ProjectPipelineAmount || 0), 0);
  }

  // Calculate the sum of amounts for items in the Closed Won column
  getClosedWonTotalAmount(): number {
    const items = this.getItemsForClosedStatus('1-5-1');
    if (!items || items.length === 0) return 0;

    return items.reduce((sum, item) => sum + (item.ProjectPipelineAmount || 0), 0);
  }

  // Calculate the sum of Backlog amounts (ProjectSaleServiceDeliveryStatus = '1') in Closed Won column
  getClosedWonBacklogAmount(): number {
    const items = this.getItemsForClosedStatus('1-5-1');
    if (!items || items.length === 0) return 0;

    return items
      .filter(item => item.ProjectPipelineSubStateCode === '1-5-1')
      .reduce((sum, item) => sum + (item.ProjectSaleServiceDeliveryWaitingAmount || 0), 0);

  }

  // Calculate the sum of New Business amounts (ProjectSaleServiceDeliveryStatus = '2') in Closed Won column
  getClosedWonNewBusinessAmount(): number {
    const items = this.getItemsForClosedStatus('1-5-1');
    if (!items || items.length === 0) return 0;

    return items
      .filter(item => item.ProjectPipelineSubStateCode === '1-5-1')
      .reduce((sum, item) => sum + (item.ProjectSaleServiceDeliveryNewBusinessAmount || 0), 0);
  }

  // Calculate the sum of amounts for items in the Closed Lost column
  getClosedLostTotalAmount(): number {
    const items = this.getItemsForClosedStatus('1-5-2');
    if (!items || items.length === 0) return 0;

    return items.reduce((sum, item) => sum + (item.ProjectPipelineAmount || 0), 0);
  }

  // Calculate the sum of amounts for items in the Suspended column
  getSuspendedTotalAmount(): number {
    const items = this.getItemsForSuspendedStatus();
    if (!items || items.length === 0) return 0;

    return items.reduce((sum, item) => sum + (item.ProjectPipelineAmount || 0), 0);
  }

  // Calculate the sum of amounts for items in the Terminated column
  getTerminatedTotalAmount(): number {
    const items = this.getItemsForTerminatedStatus();
    if (!items || items.length === 0) return 0;

    return items.reduce((sum, item) => sum + (item.ProjectPipelineAmount || 0), 0);
  }

  // Open a popup dialog showing the Pipeline view for a specific project
  openProjectPipelineDetail(item: ProjectPipelineInfo): void {
    // Filter the data to only show the selected project's pipeline
    const projectCode = item.ProjectSaleCode;

    // Filter yearMonthSet data for this specific project
    const filteredData = this.yearMonthSet.map(companyset => {
      return {
        companyName: companyset.companyName,
        result: companyset.result.filter(result =>
          result.values.some(v => v.ProjectSaleCode === projectCode)
        ).map(result => {
          return {
            name: result.name,
            owner: result.owner,
            values: result.values.filter(v => v.ProjectSaleCode === projectCode)
          };
        })
      };
    }).filter(companyset => companyset.result.length > 0);

    // Create a dialog configuration
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = false;
    dialogConfig.width = '80%';
    //dialogConfig.maxWidth = '1200px';
    dialogConfig.maxHeight = '90vh';
    dialogConfig.data = {
      projectCode: projectCode,
      projectName: item.ProjectSaleName,
      companyName: item.ProjectPipelineCompanyName,
      item: item,
      filteredData: filteredData
    };

    // Open the dialog
    const dialogRef = this.dialog.open(ProjectPipelineDetailComponent, dialogConfig);

    // Handle dialog close event if needed
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Handle any actions after dialog closes if needed
        this.LoadProjectPipelineList();
      }
    });
  }

  validated() {
    if (!!this.ddlCompany && !!this.ddlProjectSaleCode && !!this.ddlProjectProgress && !!this.txtExpectedClose
      && !!this.txtAmount && (this.txtCommission >= 0) && !!this.txtProbability) {

      $('#ddlCompany').css('border-color', 'inherit');
      $('#ddlProjectSaleCode').css('border-color', 'inherit');
      $('#ddlProjectProgress').css('border-color', 'inherit');
      $('#txtExpectedClose').css('border-color', 'inherit');
      $('#txtAmount').css('border-color', 'inherit');
      $('#txtCommission').css('border-color', 'inherit');
      $('#txtProbability').css('border-color', 'inherit');

      return true;

    } else {

      $('#ddlCompany').css('border-color', !this.ddlCompany ? 'red' : 'inherit');
      $('#ddlProjectSaleCode').css('border-color', !this.ddlProjectSaleCode ? 'red' : 'inherit');
      $('#ddlProjectProgress').css('border-color', !this.ddlProjectProgress ? 'red' : 'inherit');
      $('#txtExpectedClose').css('border-color', !this.txtExpectedClose ? 'red' : 'inherit');
      $('#txtAmount').css('border-color', !this.txtAmount ? 'red' : 'inherit');
      $('#txtCommission').css('border-color', !this.txtCommission ? 'red' : 'inherit');
      $('#txtProbability').css('border-color', !this.txtProbability ? 'red' : 'inherit');

      return false;
    }
  }

  OnDDLSearchCompanyChange() {
    //filter project ddl by company code
    if (!!this.ddlSearchCompany) {
      this.ddlSearchProjectSaleCode = null;
      this.ddlSearchProjectSaleList = this.SearchProjectSaleList.filter((i) => { return i.ProjectSaleCompanyAbbreviation === this.ddlSearchCompany });
      $('#ddlSearchProjectSaleCode').prop('disabled', false);
    } else {
      this.ddlSearchProjectSaleCode = "";
      this.ddlSearchProjectSaleList = this.SearchProjectSaleList;
      $('#ddlSearchProjectSaleCode').prop('disabled', true);
    }
    this.btnSearchPipeline_OnClick();

  }
  OnDDLCompanyChange() {
    //filter project ddl by company code
    if (!!this.ddlCompany) {
      this.ddlProjectSaleList = this.ProjectSaleList.filter((i) => { return i.ProjectSaleCompanyAbbreviation === this.ddlCompany });
      $('#ddlProjectSaleCode').prop('disabled', false);
    } else {
      this.ddlProjectSaleCode = "";
      this.ddlProjectSaleList = this.ProjectSaleList;
      $('#ddlProjectSaleCode').prop('disabled', true);
    }
  }
}
